import { FC } from 'react'

import { usePrefetchTags } from '../hooks/usePrefetchTags'

export const TagsPrefetcher: FC = () => {
	usePrefetchTags()

	return null
}
